import apiClient from './apiClient';

export async function submitFeedback({ message, category, pageUrl }) {
  const response = await apiClient.post(
    '/feedback',
    {
      message,
      category: category || undefined,
      page_url: pageUrl || undefined,
    },
    { suppressGlobalErrorToast: true }
  );
  return response.data;
}
